import type { ItemDeFatura } from "@/api/contrato";
import { dinheiro, quantidade } from "@/formato";
import { rotuloDoItem } from "./fatura";

/*
 * Os itens de uma fatura — a gravada, a da prévia ou a prevista na simulação.
 * O cálculo é um só nos três casos (`domain.CalcularFatura`), e a leitura
 * também.
 *
 * Na mensalidade, `quantidade` é dias de vigência e o unitário é a mensalidade
 * CHEIA: o valor é a proporção, arredondada para baixo. Mostrar "16/31 dias"
 * ao lado é o que deixa a conta conferível de cabeça.
 *
 * Tabela de verdade (`<table>`), e não a grade da `Tabela`: são três ou quatro
 * linhas sem clique, e o leitor de tela precisa anunciar "Valor" ao chegar em
 * cada célula de dinheiro.
 */
export function ItensDaFatura({
  itens,
  diasNaCompetencia,
  totalCentavos,
}: {
  itens: readonly ItemDeFatura[];
  diasNaCompetencia: number;
  totalCentavos: number;
}) {
  if (itens.length === 0) return <p className="text-texto-2">Nenhum item.</p>;

  return (
    <table className="w-full border-collapse text-corpo">
      <thead>
        <tr className="border-b border-fio">
          <th scope="col" className="rotulo py-1 text-left font-normal">
            Item
          </th>
          <th scope="col" className="rotulo py-1 text-right font-normal">
            Qtd.
          </th>
          <th scope="col" className="rotulo py-1 text-right font-normal">
            Unitário
          </th>
          <th scope="col" className="rotulo py-1 text-right font-normal">
            Valor
          </th>
        </tr>
      </thead>
      <tbody>
        {itens.map((item, indice) => (
          <tr key={`${item.tipo}-${item.competencia_origem}-${indice}`} className="border-b border-fio/50">
            <td className="py-1.5 text-texto">{rotuloDoItem(item)}</td>
            <td className="dados py-1.5 text-right text-texto-2">
              {item.tipo === "mensalidade"
                ? `${item.quantidade}/${diasNaCompetencia} dias`
                : quantidade(item.quantidade)}
            </td>
            <td className="dados py-1.5 text-right text-texto-2">
              {dinheiro(item.valor_unitario_centavos)}
            </td>
            <td
              className={`dados py-1.5 text-right ${item.valor_centavos < 0 ? "text-falha" : "text-texto"}`}
            >
              {dinheiro(item.valor_centavos)}
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <th scope="row" colSpan={3} className="rotulo py-1.5 text-left font-normal">
            Total
          </th>
          <td className="dados py-1.5 text-right font-semibold text-texto">
            {dinheiro(totalCentavos)}
          </td>
        </tr>
      </tfoot>
    </table>
  );
}
